var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "errPage-container" },
    [
      _c("errorA"),
      _c("errorB"),
      _c("h3", [_vm._v(_vm._s(_vm.$t("errorLog.tips")))]),
      _c("code", [
        _vm._v(" " + _vm._s(_vm.$t("errorLog.description")) + " "),
        _c(
          "a",
          {
            staticClass: "link-type",
            attrs: {
              target: "_blank",
              href:
                "https://panjiachen.github.io/vue-element-admin-site/guide/advanced/error.html"
            }
          },
          [_vm._v(" " + _vm._s(_vm.$t("errorLog.documentation")) + " ")]
        )
      ]),
      _vm._m(0)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { attrs: { href: "#" } }, [
      _c("img", {
        attrs: {
          src:
            "https://wpimg.wallstcn.com/360e4842-4db5-42d0-b078-f9a84a825546.gif"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }